import { api, errorMessage } from "@/lib/api";

const SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";
let loading = null;

/** Loads Razorpay's checkout script once. */
export function loadRazorpay() {
  if (typeof window !== "undefined" && window.Razorpay) return Promise.resolve(true);
  if (loading) return loading;
  loading = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = SCRIPT;
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => { loading = null; resolve(false); };
    document.body.appendChild(s);
  });
  return loading;
}

/**
 * Opens the Razorpay payment window for an order.
 * `rzp` is what the server returns ({ key_id, razorpay_order_id, amount, currency, name, description, prefill }).
 * Resolves { status: "paid" | "cancelled" | "failed", message? }.
 */
export async function payWithRazorpay(orderId, rzp) {
  const ok = await loadRazorpay();
  if (!ok || !window.Razorpay) return { status: "failed", message: "Could not load the payment window. Check your internet connection and try again." };
  return new Promise((resolve) => {
    let settled = false;
    const done = (r) => { if (!settled) { settled = true; resolve(r); } };
    const rp = new window.Razorpay({
      key: rzp.key_id,
      order_id: rzp.razorpay_order_id,
      amount: rzp.amount,
      currency: rzp.currency || "INR",
      name: rzp.name || "Avishka Navya Collections",
      description: rzp.description || "Order payment",
      image: `${window.location.origin}/logo.jpg`,
      prefill: rzp.prefill || {},
      theme: { color: "#0E4D34" },
      handler: async (resp) => {
        try {
          await api.post(`/orders/${orderId}/verify-payment`, {
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          done({ status: "paid" });
        } catch (e) {
          done({ status: "failed", message: errorMessage(e, "We couldn't confirm the payment. If money was deducted, it will be refunded automatically.") });
        }
      },
      modal: {
        ondismiss: async () => {
          try { await api.post(`/orders/${orderId}/payment-cancelled`); } catch { /* ignore */ }
          done({ status: "cancelled" });
        },
      },
    });
    // If a card/UPI attempt fails, Razorpay keeps its window open so the customer can try another method.
    rp.open();
  });
}
